import React from 'react'
import { useAccordionActions, useAccordionState } from './AccordionHandler'
import Panel from '../Panel'
import AccordionToggler from './AccordionToggler'
import FlexGrid, { FlexCol } from '../FlexGrid'

const AccordionHeader = ({ children, ...props }) => {
  return (
    <FlexGrid justify="space-between" align="center" flex={1} gutter={0.5}>
      <FlexCol flex={0}>
        <AccordionToggler />
      </FlexCol>

      <FlexCol flex={1}>{children}</FlexCol>
    </FlexGrid>
  )
}

export default AccordionHeader
